export default __webpack_public_path__ + "KaTeX_Main-Italic.e3954fe9b7efb3f438d218f6e8a8e049.woff";